import { render, staticRenderFns } from "./IconTooltip.vue?vue&type=template&id=3f276add&scoped=true&"
import script from "./IconTooltip.vue?vue&type=script&lang=js&"
export * from "./IconTooltip.vue?vue&type=script&lang=js&"
import style0 from "./IconTooltip.vue?vue&type=style&index=0&id=3f276add&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f276add",
  null
  
)

export default component.exports